import i18n from "lib/i18n"
import React from "react"
import { track } from "lib/analytics"

export default function PrintButton() {
  const onClick = (event) => {
    event.preventDefault()

    track("Article page - print button clicks", window.location.pathname, "", 1)
    window.print()
  }

  return (
    <div className="print">
      <a href="#" onClick={onClick}>
        <i className="icon-print" /> {i18n.t("content.button.print")}
      </a>
    </div>
  )
}
